import { RailgunBase } from '../RailgunBase';
import { BaseService } from '../Service/BaseService';
import { RailgunError } from '../RailgunError';

/**
 * BaseDAO
 *
 * DAOはBaseDAOを継承して作成するようにする
 */
export class BaseDAO extends RailgunBase {

	// DAOを呼び出すサービスを持っておく
	private parentService: BaseService;

	/**
	 * コンストラクタ
	 */
	constructor(svc: BaseService) {
		super();
		// DAOを呼び出すサービスを持っておく
		this.parentService = svc;
	}

	////////////////////////////////////////////
	// エラー関連の処理をオーバライドして、サービスに伝搬する

	/**
	 * getErrorObj
	 * エラーオブジェクトの取得
	 */
	public getErrorObj(): RailgunError {
		return this.parentService.getErrorObj();
	}

	/**
	 * setErrorObj
	 * エラーオブジェクトの設定
	 */
	public setErrorObj(obj: RailgunError)  {
		this.parentService.setErrorObj(obj);
	}


}
